import { DocumentReference } from "firebase/firestore";
import { Moment } from "moment";
import Termo from "./termoAceite";
import VersaoTermo from "./versaoTermo";

export default class Aceite implements IAceite {
  public ref!: DocumentReference<Aceite>;
  public dataAceite!: Moment;
  public termo!: DocumentReference<Termo>;
  public versao!: DocumentReference<VersaoTermo>;
  public hash?: string;

  constructor(param: IAceite) {
    Object.assign(this, param);
  }
}

interface IAceite {
  ref: DocumentReference<Aceite>;
  dataAceite: Moment;
  termo: DocumentReference<Termo>;
  versao: DocumentReference<VersaoTermo>;
  hash?: string;
}
